export const style = {
  h2: {
    textAlign: `center`,
    fontSize: `2.2em`,
    fontWeight: 300,
    lineHeight: `42px`,
    margin: `0 0 32px 0`,
    marginBottom: `10px`
  },
  blockquote: {
    textAlign: `center`,
    color: `#666`,
    fontSize: `1.1em`,
    lineHeight: `23px`
  },
  name: {
    position: `relative`,
    fontSize: `0.75em`,
    color: `#9CA6B4`,
    ':before': {
      position: `absolute`,
      content: "''",
      top: `50%`,
      width: `15px`,
      left: `-18px`,
      height: `1px`,
      background: `#9CA6B4`
    },
    ':after': {
      position: `absolute`,
      content: "''",
      top: `50%`,
      width: `15px`,
      right: `-18px`,
      height: `1px`,
      background: `#9CA6B4`
    }
  },
  divider: {
    position: `relative`,
    margin: `60px 0`,
    height: `4px`,
    borderTop: `#ddd 1px solid`,
    borderBottom: `#ddd 1px solid`
  },
  box: {
    marginBottom: `60px`
  },
  boxName: {
    position: `relative`,
    background: `#F6F6F6`,
    borderRadius: `0 0 6px 6px`,
    padding: `6px 40px 6px 40px`,
    fontSize: `0.85em`,
    color: `#666`,
    ':before': {
      position: `absolute`,
      content: "''",
      top: `50%`,
      width: `15px`,
      left: `18px`,
      height: `1px`,
      background: `#9CA6B4`
    },
    ':after': {
      position: `absolute`,
      content: "''",
      top: `50%`,
      width: `15px`,
      right: `18px`,
      height: `1px`,
      background: `#9CA6B4`
    }
  },
  boxParagraph: {
    color: `#000`,
    fontSize: `14px`,
    fontStyle: `italic`,
    lineHeight: `22px`,
    background: `#F6F6F6`,
    borderRadius: `6px 6px 6px 0`,
    padding: `15px 40px`,
    margin: `0 0 20px`,
    marginBottom: 0
  },
  boxNameStrong: {
    fontWeight: `600`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Home/style/reviews.js